import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import ChatWindow from '../components/chat/ChatWindow';
import AppLayout from '../components/layout/AppLayout';

const ChatPage: React.FC = () => {
  const { chatId } = useParams<{ chatId: string }>();

  if (!chatId) {
    return <div>Chat ID is required</div>;
  }

  return (
    <AppLayout>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <ChatWindow chatId={chatId} />
      </Box>
    </AppLayout>
  );
};

export default ChatPage;
